import React from 'react';

const FormButton = props => {
    const { isLoading, onClick } = props;

    if(isLoading){
        return <button className="btn btn-primary" type="button" disabled>
            Saving <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </button>
    }

    return (
        <button
            type="submit"
            className="btn btn-primary"
            onClick={onClick}
        ><i className="fa fa-save"></i> Submit</button>
    );
};

export default FormButton;
